import { useMemo, useState } from 'react'
import { extensionRoster } from '../state/roster'

// Reusable destination chooser: free-type an extension/number OR pick from the directory.
// Used by transfer/redirect and voicemail-forward dialogs.
export function DestinationPicker({ value, onChange, exclude, label = 'Destination', autoFocus = true }: {
  value: string
  onChange: (v: string) => void
  exclude?: string
  label?: string
  autoFocus?: boolean
}) {
  const [q, setQ] = useState('')
  const entries = useMemo(
    () => Object.entries(extensionRoster).filter(([ext]) => ext !== exclude),
    [exclude]
  )
  const filtered = useMemo(() => {
    const n = q.trim().toLowerCase()
    return n ? entries.filter(([ext, name]) => ext.includes(n) || name.toLowerCase().includes(n)) : entries
  }, [entries, q])

  return (
    <>
      <div className="sb-field">
        <label>{label}</label>
        <input
          className="sb-input" inputMode="tel" placeholder="Extension or number"
          value={value} onChange={(e) => onChange(e.target.value)} autoFocus={autoFocus}
        />
      </div>
      <input
        className="search" placeholder="Filter directory…"
        value={q} onChange={(e) => setQ(e.target.value)} aria-label="Filter directory"
      />
      <div className="sb-picklist">
        {filtered.map(([ext, name]) => (
          <button
            key={ext} type="button"
            className={value === ext ? 'sb-pick sel' : 'sb-pick'}
            onClick={() => onChange(ext)}
          >
            <span className="who"><strong>{name}</strong></span>
            <span className="faint">{ext}</span>
          </button>
        ))}
        {filtered.length === 0 ? <div className="sb-panel-empty">No directory matches.</div> : null}
      </div>
    </>
  )
}
